import { useEffect, useState } from "react";
import { getDrop, getDropAccess } from "@/lib/api";

const KEY = "sus-early-access";

export const allTokens = () => { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch { return {}; } };
export const tokenFor = (slug) => (slug ? allTokens()[slug] || null : null);
export const saveToken = (slug, t) => localStorage.setItem(KEY, JSON.stringify({ ...allTokens(), [slug]: t }));
export const dropIsLive = (d) => ["live", "sold_out"].includes(d.status) || new Date(d.release_date) <= Date.now();

export const checkAccess = async (slug) => {
  const t = tokenFor(slug);
  if (!t) return null;
  try { return await getDropAccess(slug, t); } catch { return null; }
};

export const useDropGate = (slug) => {
  const [state, setState] = useState({ loading: !!slug });
  useEffect(() => {
    if (!slug) return setState({});
    let alive = true;
    getDrop(slug).then(async (drop) => {
      if (dropIsLive(drop)) return alive && setState({ drop, gated: false });
      const a = await checkAccess(slug);
      if (alive) setState({ drop, gated: !a?.valid, access: a });
    }).catch(() => alive && setState({}));
    return () => { alive = false; };
  }, [slug]);
  return state;
};
